/* Per-user row inside the Manage Users table. */
import { CheckCircle2, XCircle, Trash2 } from "lucide-react";

export default function UserRow({
  user, isSelf, selected,
  onToggleSelect, onRoleChange, onProgramChange,
  onToggleActive, onDelete,
}) {
  const active = user.is_active !== false;
  const rowClass = `border-b border-[#C9A961]/8 ${selected ? "bg-[#C9A961]/8" : ""}`;
  return (
    <tr className={rowClass} data-testid={`user-row-${user.id}`}>
      <td className="py-2 pr-3">
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect(user.id)}
          disabled={isSelf}
          className="accent-[#C9A961] cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
          aria-label={`Select ${user.email}`}
          title={isSelf ? "You can't bulk-modify your own account" : "Select for bulk action"}
          data-testid={`select-${user.id}`}
        />
      </td>
      <td className="py-2 pr-3 text-[#F7F5F0] break-all">
        {user.email}
        {isSelf && <span className="ml-1 text-[10px] text-[#C9A961]">(you)</span>}
      </td>
      <td className="py-2 pr-3 hidden sm:table-cell text-[#D1CFC9]">{user.name}</td>
      <td className="py-2 pr-3">
        <select
          value={user.role}
          onChange={(e) => onRoleChange(user, e.target.value)}
          disabled={isSelf}
          className="input-tcpi py-1 px-2 text-xs text-[#C9A961] bg-transparent disabled:opacity-50"
          data-testid={`role-select-${user.id}`}
          title={isSelf ? "You can't change your own role" : "Change role"}
        >
          <option value="participant">participant</option>
          <option value="facilitator">facilitator</option>
          <option value="admin">admin</option>
        </select>
      </td>
      <td className="py-2 pr-3 hidden md:table-cell">
        <select
          value={user.program || "men"}
          onChange={(e) => onProgramChange(user, e.target.value)}
          className="input-tcpi py-1 px-2 text-xs text-[#D1CFC9] bg-transparent"
          data-testid={`program-select-${user.id}`}
        >
          <option value="men">men</option>
          <option value="women">women</option>
        </select>
      </td>
      <td className="py-2 pr-3">
        {active ? (
          <span className="inline-flex items-center gap-1 text-[#C9A961]">
            <CheckCircle2 className="w-3.5 h-3.5" /> active
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 text-[#8A8782]">
            <XCircle className="w-3.5 h-3.5" /> off
          </span>
        )}
      </td>
      <td className="py-2 pr-3">
        <div className="flex items-center justify-end gap-2">
          <button
            disabled={isSelf}
            onClick={() => onToggleActive(user)}
            className="text-xs px-2 py-1 rounded border border-[#C9A961]/30 text-[#D1CFC9] hover:text-[#C9A961] hover:border-[#C9A961]/65 disabled:opacity-30 disabled:cursor-not-allowed"
            data-testid={`toggle-active-${user.id}`}
          >
            {active ? "Deactivate" : "Reactivate"}
          </button>
          <button
            disabled={isSelf}
            onClick={() => onDelete(user)}
            className="text-xs px-2 py-1 rounded border border-red-500/30 text-red-400 hover:bg-red-500/10 disabled:opacity-30 disabled:cursor-not-allowed flex items-center gap-1"
            data-testid={`delete-${user.id}`}
          >
            <Trash2 className="w-3 h-3" /> Delete
          </button>
        </div>
      </td>
    </tr>
  );
}
